(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tm-blog-post-filters"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tm-blog-post-filters')) {
    class BlogPostFilters extends HTMLElement {
      constructor() {
        super();

        this.sectionId = this.dataset.sectionId;
        this.section = this.closest('.shopify-section');
        this.currentFetchController = null; // track active fetch

        this.openDrawerBtn = this.querySelector('#tm-blog-post-filters__open-drawer-btn');
        this.drawer = this.querySelector('.tm-blog-post-filters__drawer');

        if (this.openDrawerBtn && this.drawer) this.openDrawerBtn.addEventListener('click', (e) => this.openDrawer(e));

        if (!this.sectionId || !this.section) {
          console.error(`Can't find section id or section element for tm-blog-post-filters component`);
          return;
        }

        this.querySelectorAll('a').forEach((element) => {
          element.addEventListener('click', (event) => {
            event.preventDefault();
            this.onFilterChange(event, element);
          });
        });
      }

      onFilterChange(event, element) {
        // abort any previous request if still pending
        if (this.currentFetchController) {
          this.currentFetchController.abort();
        }
        const controller = new AbortController();
        this.currentFetchController = controller;

        this.setLoading(true);

        const url = element.href.replace('#filters', '') + '?sections=' + this.sectionId;

        fetch(url, { signal: controller.signal })
          .then((response) => response.json())
          .then((html) => {
            if (this.currentFetchController !== controller) return;
            this.currentFetchController = null;

            const parser = new DOMParser();
            const doc = parser.parseFromString(html[this.sectionId], 'text/html');
            const sectionSource = doc.querySelector('#shopify-section-' + this.sectionId);

            //If a dropdown is currently open, ensure it stays open after the HTML is replaced
            const openDropdownId = this.querySelector('.tm-blog-post-filters__filter[open]')?.id;
            if (openDropdownId) {
              sectionSource.querySelector('#' + openDropdownId)?.setAttribute('open', '');
            }

            const drawerSource = doc.querySelector('.tm-blog-post-filters__drawer');
            if (this.drawer.classList.contains('active') && drawerSource) drawerSource.classList.add('active');

            if (sectionSource) {
              this.section.innerHTML = sectionSource.innerHTML;

              window.history.pushState({}, '', element.href.replace('#filters', ''));

              if (event.target.id) {
                const newSelectedFilter = this.querySelector('#' + event.target.id);

                if (newSelectedFilter) newSelectedFilter.focus();
              }
            } else {
              throw new Error(`Could not find section source in fetched HTML`);
            }
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              // previous fetch was aborted; ignore
              return;
            }
            console.error('Error fetching filtered blog posts:', error);
          })
          .finally(() => {
            if (this.currentFetchController === controller || this.currentFetchController === null) {
              this.setLoading(false);
            }
          });
      }
      setLoading(loading) {
        this.isLoading = loading;
        this.section.setAttribute('aria-busy', loading ? 'true' : 'false');
        this.classList.toggle('tm-blog-post-filters--loading', loading);
      }
      openDrawer(e) {
        e.preventDefault();

        document.getElementsByTagName('body')[0].classList.add('open-cc');

        this.drawer.classList.toggle('active', true);
      }
    }
    customElements.define('tm-blog-post-filters', BlogPostFilters);
  }
  } catch(e) { console.error(e); }
})();

})();
